export const text = {
  en: {
    title: "Departments",
    subtitle: "Create, rename, merge departments and assign managers",
    unauthorized: "You don't have access to Departments",
    adminOnly: "Departments",
    company: "Company",
    allCompanies: "All companies",
    searchPlaceholder: "Search departments...",
    name: "Department",
    nameAr: "Arabic name",
    members: "Members",
    managers: "Managers",
    noManagers: "No managers",
    status: "Status",
    active: "Active",
    inactive: "Inactive",
    showInactive: "Show inactive",
    actions: "Actions",
    newDepartment: "New Department",
    createTitle: "Create Department",
    editTitle: "Edit Department",
    descriptionLabel: "Description (optional)",
    save: "Save",
    cancel: "Cancel",
    close: "Close",
    rename: "Rename",
    deactivate: "Deactivate",
    deactivateConfirm: "Deactivate this department? Members keep their assignment; the department is hidden from pickers.",
    merge: "Merge",
    mergeTitle: "Merge Departments",
    mergeInto: "Merge the selected departments into:",
    mergeWarning: "Members, managers, visibility rules and workflows move to the target. Sources are deactivated. This also rewrites the legacy Employee Type values.",
    mergeSelectHint: "Select 2+ departments with the checkboxes, then click Merge.",
    confirmMerge: "Merge",
    membersTitle: "Members",
    noMembers: "No members",
    managersTitle: "Managers",
    manager: "Manager",
    deputy: "Deputy",
    addManager: "Add manager",
    suggested: "Suggested",
    suggestedManagerHint: "Most common first-line manager among members",
    managerCodePlaceholder: "Employee Infinity Code",
    remove: "Remove",
    saved: "Saved",
    error: "Error",
    success: "Success",
    createSuccess: "Department created",
    renameSuccess: "Department updated. Legacy Employee Type values were kept in sync.",
    mergeSuccess: "Merge completed",
    managersSuccess: "Managers updated",
    deactivateSuccess: "Department deactivated",
    loadError: "Failed to load departments",
    renameCascadeNote: "Renaming also updates every member's Employee Type and all rules using this department.",
    selectCompanyFirst: "Select a company to manage its departments",
    loading: "Loading departments...",
    empty: "No departments found",
    membersCount: (n) => `${n} member${n === 1 ? "" : "s"}`,
  },
  ar: {
    title: "الأقسام",
    subtitle: "إنشاء الأقسام وإعادة تسميتها ودمجها وتعيين المديرين",
    unauthorized: "ليس لديك صلاحية الوصول إلى الأقسام",
    adminOnly: "الأقسام",
    company: "الشركة",
    allCompanies: "كل الشركات",
    searchPlaceholder: "ابحث عن قسم...",
    name: "القسم",
    nameAr: "الاسم بالعربية",
    members: "الأعضاء",
    managers: "المديرون",
    noManagers: "لا يوجد مديرون",
    status: "الحالة",
    active: "نشط",
    inactive: "غير نشط",
    showInactive: "عرض غير النشط",
    actions: "إجراءات",
    newDepartment: "قسم جديد",
    createTitle: "إنشاء قسم",
    editTitle: "تعديل القسم",
    descriptionLabel: "الوصف (اختياري)",
    save: "حفظ",
    cancel: "إلغاء",
    close: "إغلاق",
    rename: "إعادة تسمية",
    deactivate: "إلغاء التفعيل",
    deactivateConfirm: "إلغاء تفعيل هذا القسم؟ يحتفظ الأعضاء بانتمائهم ويُخفى القسم من القوائم.",
    merge: "دمج",
    mergeTitle: "دمج الأقسام",
    mergeInto: "دمج الأقسام المحددة في:",
    mergeWarning: "سيتم نقل الأعضاء والمديرين وقواعد الرؤية وسير العمل إلى القسم الهدف، وإلغاء تفعيل الأقسام المصدر، مع تحديث قيم نوع الموظف القديمة.",
    mergeSelectHint: "حدد قسمين أو أكثر بمربعات الاختيار ثم اضغط دمج.",
    confirmMerge: "دمج",
    membersTitle: "الأعضاء",
    noMembers: "لا يوجد أعضاء",
    managersTitle: "المديرون",
    manager: "مدير",
    deputy: "نائب",
    addManager: "إضافة مدير",
    suggested: "مقترح",
    suggestedManagerHint: "المدير المباشر الأكثر شيوعاً بين الأعضاء",
    managerCodePlaceholder: "كود الموظف",
    remove: "إزالة",
    saved: "تم الحفظ",
    error: "خطأ",
    success: "نجاح",
    createSuccess: "تم إنشاء القسم",
    renameSuccess: "تم تحديث القسم مع مزامنة قيم نوع الموظف القديمة.",
    mergeSuccess: "تم الدمج بنجاح",
    managersSuccess: "تم تحديث المديرين",
    deactivateSuccess: "تم إلغاء تفعيل القسم",
    loadError: "فشل تحميل الأقسام",
    renameCascadeNote: "إعادة التسمية تُحدّث أيضاً نوع الموظف لكل الأعضاء وجميع القواعد المرتبطة بالقسم.",
    selectCompanyFirst: "اختر شركة لإدارة أقسامها",
    loading: "جارٍ تحميل الأقسام...",
    empty: "لا توجد أقسام",
    membersCount: (n) => `${n} عضو`,
  },
};
